const globals = require.context('.', true, /\.js$/);
globals.keys().forEach(globals);
